import React from "react";
import {
  FaEnvelope,
  FaGithub,
  FaGoogle,
  FaLinkedin,
  FaMapMarkerAlt,
  FaUniversity,
} from "react-icons/fa";
import profileImage from "../assets/profile.jpg";
import "./About.css";

const About = () => (
  <div className="about-section">
    <div className="about-image-container">
      <img src={profileImage} alt="Profile" className="about-image" />
    </div>

    <h1 className="about-name">Taïga Gonçalves/Nakajima</h1>

    <div className="profile-meta">
      <p>Tohoku University</p>
      <p>Ph.D. Candidate</p>
    </div>

    <ul className="profile-links" aria-label="Profile links">
      <li>
        <FaMapMarkerAlt className="profile-icon" />
        <span>Sendai, Japan</span>
      </li>
      <li>
        <a href="mailto:goncalves.taiga.teo.t6@dc.tohoku.ac.jp">
          <FaEnvelope className="profile-icon" /> Email
        </a>
      </li>
      <li>
        <a
          href="https://www.linkedin.com/in/taigagoncalves/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaLinkedin className="profile-icon" /> LinkedIn
        </a>
      </li>
      <li>
        <a
          href="https://github.com/tgoncalv"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaGithub className="profile-icon" /> GitHub
        </a>
      </li>
      <li>
        <a
          href="https://scholar.google.com/citations?user=LyJa7c4AAAAJ&"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaGoogle className="profile-icon" /> Google Scholar
        </a>
      </li>
      <li>
        <a
          href="http://www.iic.ecei.tohoku.ac.jp/members.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaUniversity className="profile-icon" /> Lab. Website
        </a>
      </li>
    </ul>
  </div>
);

export default About;
